// Option-pool capacity diagnostics — emergent feature (S1). Engine layer (framework-free).
import { fullyDilutedShares } from './fullyDiluted';
/**
 * Diagnose option-pool capacity: how much pool remains, what share of FD it
 * represents, how many awards are outstanding, and how long the pool will last
 * at the current burn rate.
 *
 * `monthsOfCapacity` is `null` when the burn rate is undefined (no outstanding
 * awards or no vesting horizon); otherwise it is `poolShares / monthlyBurn`
 * where `monthlyBurn = outstandingAwards / avgVestingMonths`.
 */
export function poolCapacity(cap) {
    const poolShares = cap.instruments
        .filter((i) => i.kind === 'pool')
        .reduce((s, i) => s + Math.max(0, i.sharesAuthorized - i.sharesOutstanding), 0);
    const fdShares = fullyDilutedShares(cap);
    const poolPctFd = fdShares > 0 ? poolShares / fdShares : 0;
    const awardKinds = new Set(['option', 'warrant', 'rsu']);
    const awards = cap.instruments.filter((i) => awardKinds.has(i.kind));
    const outstandingAwards = awards.reduce((s, i) => s + Math.max(0, i.sharesOutstanding), 0);
    const vestingMonths = awards
        .map((i) => i.vestingMonths)
        .filter((m) => m !== null && m > 0);
    const avgVestingMonths = vestingMonths.length > 0 ? vestingMonths.reduce((s, m) => s + m, 0) / vestingMonths.length : null;
    const monthsOfCapacity = avgVestingMonths !== null && outstandingAwards > 0
        ? poolShares / (outstandingAwards / avgVestingMonths)
        : null;
    return { poolShares, fdShares, poolPctFd, outstandingAwards, avgVestingMonths, monthsOfCapacity };
}
//# sourceMappingURL=poolCapacity.js.map